export default __webpack_public_path__ + "c9f97ca0226f3a3a8895faf99da6ed3d.svg";